<template>
  <div class="animated fadeIn">
    <div v-if="loading">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="vx-row">
      <div class="w-full">
        <div class="customer-tab">
          <div
            slot="no-body"
            class="tabs-container pt-6"
            id="view-customer-tab"
          >
            <vs-tabs
              alignment="fixed"
              v-model="activeTab"
              class="tab-action-btn-fill-conatiner"
            >
              <vs-tab :label="$t('system.label.currency')">
                <vx-card>
                  <div class="mb-1 order-1" style="">
                    <vs-table
                      :max-items="paginationItems[0]"
                      @selected="handleSelected"
                      pagination
                      :data="currencyItems || []"
                      :description="false"
                      search
                      :description-items="paginationItems"
                      description-title="Registries"
                      description-connector="of"
                      description-body="Pages"
                    >
                      <template slot="header">
                        <div class="list-heading">
                          {{ $t("system.label.currencyConfig") }}
                        </div>
                        <div class="mr-2 mb-1 order-1">
                          <vs-button
                            icon-pack="feather"
                            icon="icon-plus"
                            @click="
                              $router
                                .push('/createCurrency?type=Currency')
                                .catch(() => {})
                            "
                            size="small"
                            >{{ $t("system.label.createCurrency") }}</vs-button
                          >
                        </div>
                      </template>
                      <template slot="thead">
                        <vs-th>{{ $t("system.label.code") }}</vs-th>
                        <vs-th>{{
                          $t("system.label.internationalNameCode")
                        }}</vs-th>
                        <vs-th>{{ $t("system.label.decimalPlaces") }}</vs-th>
                        <vs-th>{{ $t("system.label.name") }}</vs-th>
                        <vs-th>{{ $t("system.label.displaySymbol") }}</vs-th>
                        <vs-th>{{ $t("system.label.status") }}</vs-th>
                        <vs-th class="tHeadCenter">{{
                          $t("system.label.action")
                        }}</vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr
                          :key="index"
                          :data="data"
                          v-for="(currency, index) in data"
                        >
                          <vs-td :data="currency.code">{{
                            currency.code
                          }}</vs-td>
                          <vs-td :data="currency.nameCode">{{
                            currency.nameCode
                          }}</vs-td>
                          <vs-td :data="currency.decimalPlaces">{{
                            currency.decimalPlaces
                          }}</vs-td>
                          <vs-td :data="currency.name">{{
                            currency.name
                          }}</vs-td>
                          <vs-td :data="currency.displaySymbol">{{
                            currency.displaySymbol
                          }}</vs-td>
                          <vs-td :data="currency.status">
                            <vs-chip
                              v-if="currency.status"
                              :color="getStatusColor(currency.status)"
                              class="currency-status"
                              >{{ currency.status }}</vs-chip
                            >
                          </vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <div class="container_img">
                              <feather-icon
                                :title="$t('system.label.View')"
                                icon="EyeIcon"
                                @click="handleSelected(currency)"
                                svgClasses="w-5 h-5 stroke-current text-primary"
                                class="icon_row"
                              />
                              <feather-icon
                                icon="EditIcon"
                                :title="$t('system.label.Edit')"
                                class="icon_row"
                                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                                @click.stop="editData(currency.id)"
                              />
                              <feather-icon
                                icon="TrashIcon"
                                class="icon_row"
                                svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                color="danger"
                                :title="$t('system.label.Delete')"
                                type="border"
                                @click.stop="
                                  deletePopup = true;
                                  id = currency.id;
                                "
                                size="small"
                              ></feather-icon>
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </vx-card>
              </vs-tab>
              <vs-tab :label="$t('system.label.nonCurrency')">
                <vx-card>
                  <div class="mb-1 order-1" style="">
                    <vs-table
                      :max-items="paginationItems[0]"
                      @selected="handleSelected"
                      pagination
                      :data="nonCurrencyItems || []"
                      :description="false"
                      search
                      :description-items="paginationItems"
                      description-title="Registries"
                      description-connector="of"
                      description-body="Pages"
                    >
                      <template slot="header">
                        <div class="list-heading">
                          {{ $t("system.label.nonCurrency") }}
                        </div>
                        <div class="mr-2 mb-1 order-1">
                          <vs-button
                            icon-pack="feather"
                            icon="icon-plus"
                            @click="
                              $router
                                .push('/createCurrency?type=Non-Currency')
                                .catch(() => {})
                            "
                            size="small"
                            >{{
                              $t("system.label.Create") +
                              " " +
                              $t("system.label.nonCurrency")
                            }}</vs-button
                          >
                        </div>
                      </template>
                      <template slot="thead">
                        <vs-th>{{ $t("system.label.code") }}</vs-th>

                        <vs-th>{{ $t("system.label.decimalPlaces") }}</vs-th>
                        <vs-th>{{ $t("system.label.name") }}</vs-th>
                        <vs-th>{{ $t("system.label.displaySymbol") }}</vs-th>
                        <vs-th>{{ $t("system.label.status") }}</vs-th>
                        <vs-th class="tHeadCenter">{{
                          $t("system.label.action")
                        }}</vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr
                          :key="index"
                          :data="currency"
                          v-for="(currency, index) in data"
                        >
                          <vs-td :data="currency.code">{{
                            currency.code
                          }}</vs-td>

                          <vs-td :data="currency.decimalPlaces">{{
                            currency.decimalPlaces
                          }}</vs-td>
                          <vs-td :data="currency.name">{{
                            currency.name
                          }}</vs-td>
                          <vs-td :data="currency.displaySymbol">{{
                            currency.displaySymbol
                          }}</vs-td>
                          <vs-td :data="currency.status">
                            <vs-chip
                              v-if="currency.status"
                              :color="getStatusColor(currency.status)"
                              class="currency-status"
                              >{{ currency.status }}</vs-chip
                            >
                          </vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <div class="container_img">
                              <feather-icon
                                :title="$t('system.label.View')"
                                icon="EyeIcon"
                                @click="handleSelected(currency)"
                                svgClasses="w-5 h-5 stroke-current text-primary"
                                class="icon_row"
                              />
                              <feather-icon
                                icon="EditIcon"
                                :title="$t('system.label.Edit')"
                                class="icon_row"
                                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                                @click.stop="editData(currency.id)"
                              />
                              <feather-icon
                                class="icon_row text-danger"
                                icon="TrashIcon"
                                svgClasses="w-5 h-5 stroke-current cursor"
                                color="danger"
                                :title="$t('system.label.Delete')"
                                type="border"
                                @click.stop="
                                  deleteNonCurrencyPopup = true;
                                  id = currency.id;
                                "
                                size="small"
                              ></feather-icon>
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </vx-card>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('system.label.deleteCurrency')"
        :active.sync="deletePopup"
        class="popup-close small-popup"
      >
        <div class="center">
          <img src="@/assets/images/pages/delete.svg" />
          <div class="success-msg">
            {{ $t("system.label.areYouSureDelete") }}
          </div>
        </div>

        <div class="center">
          <span class="p-2">
            <vs-button type="border" @click="deletePopup = false">{{
              $t("system.label.cancel")
            }}</vs-button></span
          >

          <span class="p-2">
            <vs-button @click="deleteCurrency()">{{
              $t("system.label.confirm")
            }}</vs-button>
          </span>
        </div>
        <div style="height: 20px"></div>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        :title="$t('system.label.deleteNonCurrency')"
        :active.sync="deleteNonCurrencyPopup"
        class="popup-close small-popup"
      >
        <div class="center">
          <img src="@/assets/images/pages/delete.svg" />
          <div class="success-msg">
            {{ $t("system.label.areYouSureDelete") }}
          </div>
        </div>

        <div class="center">
          <span class="p-2">
            <vs-button type="border" @click="deleteNonCurrencyPopup = false">{{
              $t("system.label.cancel")
            }}</vs-button></span
          >

          <span class="p-2">
            <vs-button @click="deleteCurrency()">{{
              $t("system.label.confirm")
            }}</vs-button>
          </span>
        </div>
        <div style="height: 20px"></div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import currencyExchangeRates from "./currencyExchangeRates/currencyExchangeList.vue";
export default {
  data() {
    return {
      loading: false,
      activeTab: 0,
      paginationItems: [10, 20, 30],
      deletePopup: false,
      deleteNonCurrencyPopup: false,
      id: "",
      currencyItems: [],
      nonCurrencyItems: [],
    };
  },
  components: {
    AtomSpinner,
    currencyExchangeRates,
  },

  computed: {
    ...mapGetters({ currencies: "currencyMaster/getCurrencyList" }),
    ...mapState({
      deleteResponse: (state) => state.currencyMaster.getDeleteCurrencyResp,
    }),
  },
  methods: {
    handleSelected(currency) {
      const id = currency.id
      if(id){
        this.$router.push({ path: `/viewCurrency/${id}` }).catch(() => {});
      }
    },
    async getCurrencyList() {
      try {
        this.loading = true;
        await this.$store.dispatch("currencyMaster/setCurrencyList");
      } catch (e) {
        console.log("something went to wrong while Currency:", e);
      }
      this.loading = false;
    },
    async deleteCurrency() {
      this.deletePopup = false;
      this.deleteNonCurrencyPopup = false;
      this.$store
        .dispatch("currencyMaster/setdeleteCurrency", this.id)
        .then(() => {
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Deleted Successfully!",
            type: "success",
          });
        });
      await this.reloadCurrencyData();
      if (this.deleteResponse) {
        this.$router.push(`/currencyconfig`);
      }
    },
    getStatusColor(status) {
      if (status) {
        let color = "";
        status = status.toUpperCase();
        if (status === "ACTIVE") return "primary";
        if (status === "INACTIVE") return "warning";
        return color;
      }
    },
    async reloadCurrencyData() {
      await this.getCurrencyList();
      if (this.currencies && Array.isArray(this.currencies)) {
        this.currencyItems = this.currencies.filter(
          (item) => item.type === "Currency"
        );
        this.nonCurrencyItems = this.currencies.filter(
          (item) => item.type === "Non-Currency"
        );
      } else {
        this.currencyItems = [];
        this.nonCurrencyItems = [];
      }
    },

    editData(id) {
      this.$router.push(`/editCurrency/${id}`);
    },
  },
  async mounted() {
    this.loading = true;
    await this.reloadCurrencyData();
    this.loading = false;
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.currency-status.vs-chip-primary {
  background: #b5dafb !important;
  border: 1px solid #3c6bec;
  color: #3c6bec !important;
}
.currency-status.vs-chip-warning {
  background: #fdf6db !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
//::v-deep .vs-tabs--ul {
// width: 35%;
//}
</style>
